import * as React from "react";
import { HRQuestionId } from "../../messages";
import { HRQuestionWithStatus } from "../../models/HR";
import { HRQuestion } from "../../messages/HR";
import { GenericInputHeader } from "./GenericInputHeader";
import { HRQuestionTemplateId } from "../../messages/ObjectIds";
import { Globals } from "../../Globals";

interface GenericNumericInputProps {
    hrNumericQuestionWithStatus: HRQuestionWithStatus<HRQuestion.NumericQuestion>;
    isHidden: boolean;
    onChange: (newVal: string | null, id: HRQuestionId) => void;
    onBlur: (questionId: HRQuestionId) => void;
}

export class GenericNumericInput extends React.Component<GenericNumericInputProps> {
    constructor(props: GenericNumericInputProps) {
        super(props);
        if (props.hrNumericQuestionWithStatus.question.answer !== null && props.hrNumericQuestionWithStatus.question.answer.length > 0) {
            return;
        }
        const lastPick = Globals.getAnswerByTemplateId(props.hrNumericQuestionWithStatus.question.textId);
        if (lastPick !== null) {
            this.handleChange(lastPick, props.hrNumericQuestionWithStatus.question.id);
            props.onBlur(props.hrNumericQuestionWithStatus.question.id);
        }
    }

    handleChange(newVal: string, questionId: HRQuestionId) {
        let toSend: null | string = null;
        if (newVal.length > 0) {
            toSend = newVal;
        }
        this.props.onChange(toSend, questionId);
    }

    render() {
        const question = this.props.hrNumericQuestionWithStatus.question;
        const status = this.props.hrNumericQuestionWithStatus.status;
        return (
            <div className="control-group" style={this.props.isHidden ? { display: "none" } : { display: "" }}>
                <GenericInputHeader status={status} questionText={question.questionText}/>
                <input
                    required={question.isMandatory}
                    id={HRQuestionTemplateId.unwrap(question.textId)}
                    className={"form-control"}
                    type={"number"}
                    onChange={(e) => this.handleChange(e.target.value, question.id)}
                    placeholder={"Number"}
                    value={question.answer === null ? "" : question.answer}
                    onBlur={() => this.props.onBlur(question.id)}
                />
            </div>);

    }
}



// WEBPACK FOOTER //
// ./src/components/inputs/GenericNumericInput.tsx